import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import RouterApp from './RouterApp'

const App: React.FC = () => {
  return (
    <Router>
      <RouterApp />
    </Router>
  )
}

export default App
